<template>
    <div id="fullPage" class="fullPage" 
    :style="{height: heightCheck}"
    @mousedown="down" @touchstart.stop="down"
    @mousemove="move" @touchmove.stop="move"
    @mouseup="end" @touchend.stop="end">

        <!-- redirectMenu 움직임 animation -->
        <Transition id="redirectMenuTransition" name="redirectTransition">

            <RedirectMenu/>

        </Transition>
        
        <div class="sections-menu">
            
            <span class="menu-point" :class="{active: activeSection == index}" @click="scrollToSection(index)"
             v-for="(offset, index) in offsets" :key="index">
            </span>
        </div>
        
        <section class="section section1">
            <MainCenter1></MainCenter1>
        </section>
        <section class="section section2" style="overflow: hidden;">
            <MainCenter2></MainCenter2>
        </section>
        <section class="section section3" style="overflow: hidden;">
            <MainCenter3></MainCenter3>
        </section>
    </div> 
</template>

<script>
import MainCenter1 from './mainCenter1.vue'
import MainCenter2 from './mainCenter2.vue'
import MainCenter3 from './mainCenter3.vue'
import RedirectMenu from '@/pages/center/redirectMenu.vue'

export default {
    components:{
        MainCenter1,
        MainCenter2,
        MainCenter3,
        RedirectMenu
    },
    data() {
        return {
            inMove: false,
            activeSection: 0,
            offsets: [],
            touchStartY: 0,
            mobileTouch: true,
            checkMobile: false,
            dx: 0,
            dy: 0,
            position: {
                x: 320,
                y: 60
            },
            screenWidth: window.screen.width,
            screenHeight: window.screen.height,
            flags: false,
            heightCheck: "hidden"
        }
    },
    methods: {
        calculateSectionOffsets() {
            var sections = document.getElementsByTagName('section');
            var length = sections.length;
             
            for(var i = 0; i < length; i++) {
                var sectionOffset = sections[i].offsetTop;
                this.offsets.push(sectionOffset);
                //배열에 집어넣기
            }
        },
        isMobile() {
            var user = navigator.userAgent;

            // console.log(user)

            if( user.indexOf("iPhone") > -1 
                || user.indexOf("Android") > -1 
                || user.indexOf("iPad") > -1
                || user.indexOf("iPod") > -1
            ) {
                this.checkMobile = true;
            }
        },
        down(event){

            this.flags = true;

            var touch;

            if(event.touches){
                touch = event.touches[0];
            }else {
                touch = event;
            }

            this.dx = touch.clientX - event.target.offsetLeft
            this.dy = touch.clientY - event.target.offsetTop

        },
        move(event) {

            if(this.flags) {
                var touch;

                if (event.touches) {
                    touch = event.touches[0];
                } else {
                    touch = event;
                }

                this.position.x = touch.clientX - this.dx;
                this.position.y = touch.clientY - this.dy;

                if (this.position.x < 0) {
                    this.position.x = 0
                } 
                else if (this.position.x > this.screenWidth - touch.target.clientWidth) {
                    this.position.x = this.screenWidth - touch.target.clientWidth
                }

                if (this.position.y < 0) {
                    this.position.y = 0
                } else if (this.position.y > this.screenHeight - touch.target.clientHeight) {
                    this.position.y = this.screenHeight - touch.target.clientHeight
                }

                document.addEventListener("touchmove",(ev) => {
                    ev.preventDefault();
                },false);
            }
        },
        end() {
            this.flags = false;
        },
        //section 배열의 길이, offsets에 넣기
        handleMouseWheel: function(e) {
        
            if (e.wheelDelta < 30 && !this.inMove) {
                this.moveUp();
            } else if (e.wheelDelta > 30 && !this.inMove) {
                this.moveDown();
            } 
                
            e.preventDefault();
            return false;
        },
        //Chrome 외 타 사이트 적용부분
        handleMouseWheelDOM: function(e) {
            if (e.detail > 0 && !this.inMove) {
                this.moveUp();
            } else if (e.detail < 0 && !this.inMove) {
                this.moveDown();
            }
            
            return false;
        },
        //scroll up, down , 한번만 작동.
        moveDown() {
            this.inMove = true;

            this.activeSection--;
                
            if(this.activeSection < 0) {
                this.activeSection = 0
            }

            this.scrollToSection(this.activeSection, true);
        },
        moveUp() {
            this.inMove = true;
            this.activeSection++;
                
            if(this.activeSection > this.offsets.length - 1) {
                this.activeSection = 2;
            }

            this.scrollToSection(this.activeSection, true);
        },
        scrollToSection(id, force = false) {
            if(this.inMove && !force) return false;

            this.activeSection = id;
            //id = index = true,false
            this.inMove = true;

            let element = document.getElementsByTagName('section')[id];
            
            element.scrollIntoView({ behavior: "smooth" });
            //error point(TypeError)
           
            setTimeout(() => {
                this.inMove = false;
            }, 400);
            //scroll time
        },
        //mobile 감지 swipe
        touchStart(e) {
            e.preventDefault();
            
            this.touchStartY = e.touches[0].clientY;
        },
        touchMove(e) {
            if(this.inMove) { 
                return false;
            }
                
            e.preventDefault();
            
            const currentY = e.touches[0].clientY;
            
            if(this.touchStartY < currentY) {
                this.moveDown();
            } else {
                this.moveUp();
            }
            this.touchStartY = 0;
            return false;
        },
        openPopup() {
        
            if (this.$store.state.popupCheck == false) {
                // open window
                window.open('/popup/gmuc', '_blank', 'width=500px, height=600px, top=50, left=50, scrollbars= 0, toolbar=0, menubar=no');
                // cookies reset
            }

            console.log("open");

            this.$store.state.popupCheck = true;
            
            console.log("popupOpenCookieFinalCheck: " + this.$store.state.popupCheck);
        }
    },
    mounted() {
        this.isMobile();

        if (!this.checkMobile) {
            this.openPopup();
        } 

        if(this.checkMobile == true) {
            window.scrollTo(0, 0);
        }

        // this.mobileStyleChange();

        window.addEventListener('touchmove', () => {
            this.mobileTouch = false;
        });

        window.addEventListener('touchstart', () => {
            this.mobileTouch = true;
        });

        window.addEventListener('touchcancel', () => {
            this.mobileTouch = true;
        });

        window.addEventListener('touchend', () => {
            this.mobileTouch = true;
        });

        if(!this.checkMobile) {
            this.calculateSectionOffsets();
            //배열, 함수 생성
            
            window.addEventListener('DOMMouseScroll', this.handleMouseWheelDOM);  // Mozilla Firefox
            window.addEventListener('mousewheel', this.handleMouseWheel, { passive: false }); // Other browsers
            
            // window.addEventListener('touchstart', this.touchStart, { passive: false }); // mobile devices
            // window.addEventListener('touchmove', this.touchMove, { passive: false }); // mobile devices
        } 

        if(this.checkMobile) {
            this.heightCheck = "inherit"
        }
    },
    destroyed() {
        if(!this.checkMobile) {
            window.removeEventListener('mousewheel', this.handleMouseWheel, { passive: false });  // Other browsers
            window.removeEventListener('DOMMouseScroll', this.handleMouseWheelDOM); // Mozilla Firefox
            
            // window.removeEventListener('touchstart', this.touchStart); // mobile devices
            // window.removeEventListener('touchmove', this.touchMove); // mobile devices
        }
    },
    unmounted() {

        window.removeEventListener('touchmove', () => {});
        window.removeEventListener('touchstart', () => {});
        window.removeEventListener('touchcancel', () => {});
        window.removeEventListener('touchend', () => {});

    }
}
</script>

<style scoped>
@import '../../assets/css/reset.css';
    .fullPage{
        margin: 0;
        height: 100vh;
        width: 100vw;
        /* 화면에 맞게 가득 차게 만듬. scroll bar 없어짐 */
        /* width: 100%; */
        overflow: hidden;
        /* 참조시 scroll bar 생성이 되며 animate 없어짐 / visible로 변환시 스크롤바가 생기지만 animate 작동안함*/
    } 
    .section {
        height: 100vh;
        width: 100%;
        float: right;
        justify-content: center;
        align-items: center;
        align-content: center;
        flex-direction: column;
        overflow: hidden;
        /* 바뀌어도 아무런 상태변화 없음... */
    }
    .section1 {
        background: transparent url('@/components/image/home2.jpg') 0% 0% no-repeat padding-box;
        height: 100vh;
        width: 100vw;
        background-size: cover;
        /* 이미지가 화면 가득차게 만듬. MainPage에서 이미지를 넣을 시 다른 페이지에서도 보여짐 */
    }
    .section2 {
        height: 100vh;
        width: 100vw;
        background: transparent url('@/components/image/background2.png') 0% 0% no-repeat padding-box;
        background-size: cover;
    }
    .section3 {
        height: 100vh;
        width: 100vw;
        background: #FFFFFF 0% 0% no-repeat padding-box;
    }

    /* scroll button */
    .sections-menu {
        /* 배경보다 위에 있게 만듬 */
        position: fixed;
        /* 그렇다고 참조로 바꾸면 배경이 내려감. + 아이콘이 안보이는 오류 있음. */
        right: 4rem;
        top: 50vh;
        transform:translateY(-50%);
    }

    .sections-menu .menu-point {
        width: 10px;
        height: 10px;
        /* point 크기 */
        background-color: #000000;
        display: block;

        margin: 2rem 0;
        /* margin size */
        opacity: .6;
        /* 투명도 */
        transition: .4s ease all;
        /* 변하는 속도 조정 */
        cursor: pointer;

        border-radius: 100%;
        /* 원모양으로 변환 */
    }

    .sections-menu .menu-point.active {
        opacity: 1;
        transform:scale(1.5);
        /* active일 때 투명도와 크기 조정 */
    }

    .redirectMenuMain {
        position: fixed;
        /* 그렇다고 참조로 바꾸면 배경이 내려감. + 아이콘이 안보이는 오류 있음. */
        right: 1%;
        top: 500px;
        transform: translateY(-70%);
        margin-right: 7%;
        width: auto;
        float: right;
        z-index: 5;
    }

    /* 반응형 웹 CSS */
    @media all and (max-width: 1872px) {
        .redirectMenuMain {
            display: none;
        }
    }
    @media all and (max-width: 1474.5px) {
        .sections-menu {
            display: none;
        }
    }

    @media all and (min-width: 1200px) {
        /* .section1 {
            overflow: auto;
        } */

        .section2 {
            overflow: auto;
        }

        .section3 {
            overflow: auto;
        }
    }

    @media all and (max-width: 768px) {
        .section {
            height: 100% !important;
        }
    }

    /* 높이 반응형 css */

    @media all and (max-height: 745px) {

        .redirectMenuMain {
            display: none;
        }
        
    }

</style>